module.exports = __webpack_public_path__ + "img/failed.dfec7167.png";